/**
 * Inter variável self-hosted (SPEC 9.3, 10.4, Apêndice A): só fora da Apple (ou por escolha em
 * Ajustes › Aparência). Eixo de peso (100–900), `font-display: swap`. Sem Google Fonts nem CDN
 * (LGPD, CSP `default-src 'self'`).
 *
 * Só o subset latin (47 KB woff2): ele cobre todo o pt-BR (á, â, ã, ç, é, ê, í, ó, ô, õ, ú, ü),
 * os sinais da interface (·, ×, −, …, ↑, ↓, €) e o teto de 110 KB do 10.4. O latin-ext (83 KB, para
 * ő, ł, ş, vietnamita) estourava o orçamento sem uso no painel: um caractere raro fora do latin cai
 * na fonte do sistema, sem quadrado vazio.
 *
 * A face só entra depois da primeira pintura útil (10.4): os 47 KB não disputam o 4G com o JS e os
 * números até o LCP. Até lá o texto sai na "Inter Fallback" (base.css: Arial com as métricas da
 * Inter), então a troca não reflui a página (CLS).
 */
import latin from '@fontsource-variable/inter/files/inter-latin-wght-normal.woff2?url';
import { whenPainted } from './afterPaint';

/** Sem tela que marque a pintura (404, "Sem acesso"), a fonte entra mesmo assim. */
const FONT_FALLBACK_MS = 1200;

const FAMILY = 'Inter';
const LATIN =
  'U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD';

let loaded = false;

/** Registra a face da Inter. Idempotente; seguro chamar mais de uma vez. */
export function loadInter(): void {
  if (loaded || typeof document === 'undefined' || typeof FontFace === 'undefined') return;
  loaded = true;
  const face = new FontFace(FAMILY, `url(${latin}) format("woff2")`, {
    weight: '100 900',
    style: 'normal',
    display: 'swap',
    unicodeRange: LATIN,
  });
  whenPainted(() => {
    document.fonts.add(face);
    void face.load().catch(() => {});
  }, FONT_FALLBACK_MS);
}

/** Liga a Inter quando o `<html>` pede (`data-font="inter"`), agora e se a preferência mudar. */
export function watchFontPreference(root: HTMLElement = document.documentElement): void {
  if (root.dataset.font === 'inter') loadInter();
  const obs = new MutationObserver(() => {
    if (root.dataset.font === 'inter') {
      loadInter();
      obs.disconnect();
    }
  });
  obs.observe(root, { attributes: true, attributeFilter: ['data-font'] });
}
